import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { Role } from 'src/app/utils/Role';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent implements OnInit {

  userRoles: string[];
  allRoles: any;

  constructor(
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    private keycloakService: KeycloakService
  ) {

  }

  ngOnInit() {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Administración', url: 'provision/management' },
          { title: 'Catálogo', url: 'provision/management/catalog' }
        ]
      });
    this.allRoles = Role;
    this.userRoles = this.keycloakService.getUserRoles();
  }

  public goToCatalogueLoad(): void {
    this.router.navigate([`/provision/management/catalog/load`]);
  }

  public goToCatalogueSearch(): void {
    this.router.navigate([`/provision/management/catalog/search`]);
  }

}
